<style lang="less">
  .set-title {
    margin-left: 20px;
    font-size: 14px;
    line-height: 36px;
    color: #606266;
    span {
      margin-right: 10px;
    }
  }
  .el-switch.is-disabled {
    opacity: 1;
    filter: alpha(opacity=100);
    .el-switch__core {
      cursor: pointer;
    }
  }
</style>

<template>
  <el-card>
    <div slot="header">
      <h1>{{ activity ? '“' + activity.activityName + '”' : '' }}页面设置</h1>
    </div>
    <el-tabs type="card" v-model="tabName" @tab-click="handleClick" :before-leave="handleLeave">
      <el-tab-pane label="首页显示设置" name="home-show">
        <div style="padding: 0 20px;margin: 25px 0">
          <div class="set-title">
            <span>是否启用：</span>
            <el-switch
              v-model="homeShow"
              active-color="#13ce66"
              inactive-color="#ff4949"
              disabled
              @click.native="changeHomeShow">
            </el-switch>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="轮播图" name="carousel-list">轮播图</el-tab-pane>
      <el-tab-pane label="本月主打" name="flagship">本月主打</el-tab-pane>
      <el-tab-pane label="商品推荐" name="recommend">商品推荐</el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  const { mapGetters } = createNamespacedHelpers('activities')
  const homeShowEnum = {
    true: '启用',
    false: '禁用'
  }

  export default {
    data() {
      return {
        tabName: 'home-show',
        activity: null,
        loading: false,
        homeShow: false
      }
    },
    methods: {
      handleClick(tab) {
        if (tab.name != this.tabName) {
          this.$router.push({ name: 'activity-activity-pagesetting-' + tab.name, query: { activityId: this.activity.id }})
        }
      },
      handleLeave() {
        return false
      },
      async changeHomeShow() {
        const setHomeShow = !this.homeShow
        await this.$confirm('确定' + homeShowEnum[setHomeShow] + '首页显示？', '提示', {
          type: 'warning'
        }).then(async () => {
          try {
            this.loading = true
            await this.$store.dispatch('activities/update', { id: this.activity.id, homeShow: setHomeShow })
            this.homeShow = setHomeShow
            this.$message.success('设置成功')
          } catch (err) {
            this.$message.error('设置失败')
          } finally {
            this.loading = false
          }
        }).catch(() => {
          return false
        })
      }
    },
    async mounted() {
      const { activityId = 0 } = this.$route.query
      try {
        const { document } = await this.$store.dispatch('activities/document', activityId)
        this.activity = document
      } catch (err) {
        this.$message.error('活动不存在')
        this.$router.push({ name: 'activity-activity' })
      }
      this.homeShow = this.activity.homeShow
    }
  }
</script>
